import AfterSalesLayout from "../aftersaleslayout/AfterSalesLayout";
import FallbackImg from "../../../components/FallbackImg";
import BackBlue from "../../../assets/aftersalesservice_icons/back_blue_icon.svg";
import UserManualInstallIcon from "../../../assets/aftersalesservice_icons/user_manual_install_icon.svg";
import BeforeInstall from "../../../assets/aftersalesservice_icons/before_install_icon.svg";
import BeforeInstall1 from "../../../assets/aftersalesservice_icons/before_install_1_icon.svg";
import OnInstall from "../../../assets/aftersalesservice_icons/on_install_icon.svg";
import OnInstall1 from "../../../assets/aftersalesservice_icons/on_install_1_icon.svg";
import DuringInstall from "../../../assets/aftersalesservice_icons/during_install_icon.svg";
import IndoorIcon from "../../../assets/aftersalesservice_icons/indoor_unit_icon.svg";
import Indoor1 from "../../../assets/aftersalesservice_icons/indoor_unit_1_icon.svg";
import OutdoorIcon from "../../../assets/aftersalesservice_icons/outdoor_unit_icon.svg";
import Outdoor1 from "../../../assets/aftersalesservice_icons/outdoor_unit_1_icon.svg";
import CriticalIcon from "../../../assets/aftersalesservice_icons/critical_install_icon.svg";
import Critical1 from "../../../assets/aftersalesservice_icons/critical_install_1_icon.svg";
import AfterInstallIcon from "../../../assets/aftersalesservice_icons/after_install_icon.svg";
import AfterInstall1 from "../../../assets/aftersalesservice_icons/after_install_1_icon.svg";
import { useLanguage } from "../LanguageContext";

const UserManualInstallation = () => {
  const { trans } = useLanguage();

  return (
    <AfterSalesLayout>
      <div
        className="as-user-manual-install-content"
        id="user_manual_installation_modal"
      >
        <div style={{ padding: "0 31.97px" }}>
          <div className="as-user-manual-install-container">
            <button
              type="button"
              className="as-back-btn"
              id="user_manual_installation_back"
              onClick={() => window.history.back()}
            >
              <FallbackImg src={BackBlue} alt="back_blue_icon" />
              {trans.back_manual}
            </button>

            <div className="as-user-manual-install-main">
              <FallbackImg
                src={UserManualInstallIcon}
                alt="user_manual_install_icon"
              />
              <div>
                <div className="as-user-manual-install-main-title">
                  {trans.install_guideline}
                </div>
                <div className="as-user-manual-install-main-text">
                  {trans.install_guideline_sub}
                </div>
              </div>
            </div>
          </div>

          <div className="as-before-install-container">
            <div className="as-before-install-title">
              <FallbackImg src={BeforeInstall} alt="before_install_icon" />
              <div>{trans.before_install}</div>
            </div>
            <div className="as-before-install-box">
              <FallbackImg src={BeforeInstall1} alt="before_install_1_icon" />
              <div>
                {trans.before_install_sub_1}{" "}
                <strong>{trans.before_install_sub_1_strong}</strong>
              </div>
            </div>
            <div className="as-before-install-box">
              <FallbackImg src={BeforeInstall1} alt="before_install_1_icon" />
              <div>{trans.before_install_sub_2}</div>
            </div>
            <div className="as-before-install-box">
              <FallbackImg src={BeforeInstall1} alt="before_install_1_icon" />
              <div>{trans.before_install_sub_3}</div>
            </div>
            <div className="as-before-install-box">
              <FallbackImg src={BeforeInstall1} alt="before_install_1_icon" />
              <div>{trans.before_install_sub_4}</div>
            </div>
            <div className="as-before-install-box">
              <FallbackImg src={BeforeInstall1} alt="before_install_1_icon" />
              <div>{trans.before_install_sub_5}</div>
            </div>
          </div>

          <div className="as-on-install-container">
            <div className="as-on-install-title">
              <FallbackImg src={OnInstall} alt="on_install_icon" />
              <div>{trans.on_install}</div>
            </div>
            <div className="as-on-install-text">
              <FallbackImg src={OnInstall1} alt="on_install_1_icon" />
              <div className="as-on-install-list">
                <div>{trans.on_install_subtitle_1}</div>
                <ul>
                  <li>{trans.on_install_sub_1}</li>
                  <li>{trans.on_install_sub_2}</li>
                </ul>
              </div>
            </div>
            <div className="as-on-install-text">
              <FallbackImg src={OnInstall1} alt="on_install_1_icon" />
              <div className="as-on-install-list">
                <div>{trans.on_install_subtitle_2}</div>
                <ul>
                  <li>{trans.on_install_sub_3}</li>
                  <li>{trans.on_install_sub_4}</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="as-during-install-container">
            <div className="as-during-install-title">
              <FallbackImg src={DuringInstall} alt="during_install_icon" />
              <div>{trans.during_install}</div>
            </div>

            <div className="as-during-install-title">
              <FallbackImg src={IndoorIcon} alt="indoor_unit_icon" />
              <div>{trans.indoor_spacing}</div>
            </div>
            <div className="as-during-install-box as-purple">
              <div className="as-during-install-text">
                <FallbackImg src={Indoor1} alt="indoor_unit_1_icon" />
                <div>
                  <div>{trans.indoor_spacing_sub_1}</div>
                  <div style={{ color: "#8200DB" }}>
                    {trans.indoor_spacing_sub_2}
                  </div>
                </div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={Indoor1} alt="indoor_unit_1_icon" />
                <div>
                  <div>{trans.indoor_spacing_sub_3}</div>
                  <div style={{ color: "#8200DB" }}>
                    {trans.indoor_spacing_sub_4}
                  </div>
                </div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={Indoor1} alt="indoor_unit_1_icon" />
                <div>
                  <div>{trans.indoor_spacing_sub_5}</div>
                  <div style={{ color: "#8200DB" }}>
                    {trans.indoor_spacing_sub_6}
                  </div>
                </div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={Indoor1} alt="indoor_unit_1_icon" />
                <div>
                  <div>{trans.indoor_spacing_sub_7}</div>
                  <div style={{ color: "#8200DB" }}>
                    {trans.indoor_spacing_sub_8}
                  </div>
                </div>
              </div>
            </div>

            <div className="as-during-install-title">
              <FallbackImg src={OutdoorIcon} alt="outdoor_unit_icon" />
              <div>{trans.outdoor_spacing}</div>
            </div>
            <div className="as-during-install-box as-orange">
              <div className="as-during-install-text">
                <FallbackImg src={Outdoor1} alt="outdoor_unit_1_icon" />
                <div>
                  <div>{trans.outdoor_spacing_sub_1}</div>
                  <div style={{ color: "#CA3500" }}>
                    {trans.outdoor_spacing_sub_2}
                  </div>
                </div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={Outdoor1} alt="outdoor_unit_1_icon" />
                <div>
                  <div>{trans.outdoor_spacing_sub_3}</div>
                  <div style={{ color: "#CA3500" }}>
                    {trans.outdoor_spacing_sub_4}
                  </div>
                </div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={Outdoor1} alt="outdoor_unit_1_icon" />
                <div>
                  <div>{trans.outdoor_spacing_sub_5}</div>
                  <div style={{ color: "#CA3500" }}>
                    {trans.outdoor_spacing_sub_6}
                  </div>
                </div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={Outdoor1} alt="outdoor_unit_1_icon" />
                <div>
                  <div>{trans.outdoor_spacing_sub_7}</div>
                  <div style={{ color: "#CA3500" }}>
                    {trans.outdoor_spacing_sub_8}
                  </div>
                </div>
              </div>
            </div>

            <div className="as-during-install-box as-yellow">
              <div
                className="as-during-install-title"
                style={{ color: "#733E0A" }}
              >
                <FallbackImg src={CriticalIcon} alt="critical_install_icon" />
                <div>{trans.critical_install}</div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={Critical1} alt="critical_install_1_icon" />
                <div>{trans.critical_install_sub_1}</div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={Critical1} alt="critical_install_1_icon" />
                <div>{trans.critical_install_sub_2}</div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={Critical1} alt="critical_install_1_icon" />
                <div>
                  <strong>{trans.critical_install_sub_3_strong}</strong>
                  {trans.critical_install_sub_3}
                </div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={Critical1} alt="critical_install_1_icon" />
                <div>{trans.critical_install_sub_4}</div>
              </div>
            </div>

            <div className="as-during-install-title">
              <FallbackImg src={AfterInstallIcon} alt="after_install_icon" />
              <div>{trans.after_install}</div>
            </div>
            <div className="as-during-install-box as-green">
              <div className="as-during-install-text">
                <FallbackImg src={AfterInstall1} alt="after_install_1_icon" />
                <div>{trans.after_install_sub_1}</div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={AfterInstall1} alt="after_install_1_icon" />
                <div>{trans.after_install_sub_2}</div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={AfterInstall1} alt="after_install_1_icon" />
                <div>{trans.after_install_sub_3}</div>
              </div>
              <div className="as-during-install-text">
                <FallbackImg src={AfterInstall1} alt="after_install_1_icon" />
                <div>{trans.after_install_sub_4}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AfterSalesLayout>
  );
};

export default UserManualInstallation;
